var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import VolunteerServiceContext from '../../volunteer-service/VolunteerServiceContext';
import { useContext } from 'react';
import AssignmentForm from './AssignmentForm';
import useAsync from '../../hooks/UseAsync';
import useForm from '../../hooks/UseForm';
import PhraseContext from '../../phrase/PhraseContextInterface';
function RegisterAssignment() {
    const { registerAssignment } = useContext(VolunteerServiceContext);
    const { phrase } = useContext(PhraseContext);
    const { formState, handleChange } = useForm({
        initialState: {
            id: null,
            title: '',
            description: '',
            employer: {
                name: '',
                website: '',
                contacts: [
                    {
                        name: '',
                        email: '',
                    },
                ],
            },
            signUp: {
                type: undefined,
                link: '',
                phone: '',
                email: '',
                deadline: undefined,
                hasDeadline: '',
            },
            location: {
                address: '',
                postal: '',
                city: '',
            },
        },
    });
    const inspect = useAsync(() => __awaiter(this, void 0, void 0, function* () { return formState; }), 'loading');
    return inspect({
        pending: (state, assignment) => (_jsx(AssignmentForm, { onSubmit: (i) => null, handleChange: handleChange, formState: formState, isLoading: true })),
        resolved: (assignment, state, update) => (_jsx(AssignmentForm, { handleChange: handleChange, onSubmit: (input) => update(registerAssignment(input), 'saving'), formState: (assignment === null || assignment === void 0 ? void 0 : assignment.id) && typeof (assignment === null || assignment === void 0 ? void 0 : assignment.id) === 'number' ? assignment : formState, isSubmitted: (assignment === null || assignment === void 0 ? void 0 : assignment.id) && typeof (assignment === null || assignment === void 0 ? void 0 : assignment.id) === 'number' ? true : undefined })),
        rejected: (err, state, update, assignment) => (_jsx(AssignmentForm, { handleChange: handleChange, formState: formState, onSubmit: (input) => update(registerAssignment(input), 'saving'), errorMessage: phrase('error_text', 'Something went wrong, please try again later.') })),
    });
}
export default RegisterAssignment;
